import crel from 'crel'
import settings from '../../../src/es6/settings'
import $ from 'jquery'
import { Q, toggleClass } from '../../../src/es6/util'

//to check when element get's position sticky
var observer = new IntersectionObserver(
    function(entries) {
        // no intersection
        if (entries[0].intersectionRatio === 0)
            Q(".menu1__home").classList.remove("invisible")
        // fully intersects
        else if (entries[0].intersectionRatio < 1)
            Q(".menu1__home").classList.add("invisible")
    },
    { threshold: [0, 1] }
)
$(function () {
    observer.observe(Q(".menu1__home_big"))
})


function menu_overlay(e) {
    e.preventDefault()
    const burger = Q(".menu3__btn_burger")
    const icon = burger.querySelector('i')
    const menu = Q('.menu4')
    const body = document.body

    toggleClass(body, 'noscroll')
    toggleClass(menu, 'hidden')

    toggleClass(icon, 'fa-bars')
    toggleClass(icon, 'fa-times')
}

// window.addEventListener('hashchange', burger_menu)


$(function() {
    const burger = Q(".menu3__btn_burger")
    burger.addEventListener('click', menu_overlay)
})